export const SvgIconSrc = {
  arrow: '/icons/arrow.svg',
  backButton: '/icons/back-button.svg',
  arrowChevron: '/icons/arrow-chevron.svg',
  uptrend: '/icons/uptrend.svg',
  downtrend: '/icons/downtrend.svg',
  delete: '/icons/delete.svg',
  edit: '/icons/edit.svg',
  cross: '/icons/cross.svg',
  vericalOptions: '/icons/vertical-options.svg',
  checkbox: '/icons/checkbox-v.svg',
  visa: '/icons/visa.svg',
  mastercard: '/icons/mastercard.svg',
  creditCard: '/icons/credit-card.svg',
  info: '/icons/info.svg',
  upi: '/icons/upi.svg',
  logout: '/icons/logout.svg',
  pieChart: '/icons/pie-chart.svg',
  sidebarCollapse: '/icons/sidebar-collapse.svg',
  stopwatch: '/icons/stopwatch.svg',
  crown: '/icons/crown.svg',
};
